<template>
  <div class="layout__container">
    <h3 class="text__align-center text__colour-teal">New users from last month</h3>
    <div class="layout__position-center">
      <div class="layout__position-left layout__width-100">
        <NewBranchesSearch
          v-if="! isGettingTotal"
          :sales="sales"
          :search-params="searchParams"
          @report-type-changed="onReportTypeChanged"
        />
      </div>
      <div class="insights-table layout__width-100 layout__position-left">
        <el-table
          class="el-table__09vh"
          :data="sales"
          height="620px"
          @sort-change="handleSortOrderChange"
          v-loading.fullscreen.lock="loading || isGettingTotal"
          element-loading-text="Loading..."
          element-loading-background="rgba(79, 147, 168, 0.2)"
          empty-text="No data has been returned for the selected dates"
        >
          <el-table-column
            v-for="newBranch in NewBranches.fields()"
            :key="`${newBranch}.${new Date()}`"
            :prop="newBranch"
            :show-overflow-tooltip="true"
            :min-width="NewBranches.getColumnWidth(newBranch)"
            :label="NewBranches.getReadable(newBranch)"
            class-name="layout__width-150px el-table-column__no-pointer"
            sortable="custom"
          />
        </el-table>
      </div>

      <div
        v-if="searchParams.total"
        class="layout__padding-clear layout__width-60"
      >
        <div class="layout__padding-20-0 text__align-center">
          <el-pagination
            :current-page="searchParams.currentPage"
            :page-size="searchParams.pagination"
            layout="prev, pager, next"
            :total="searchParams.total"
            @update:currentPage="onCurrentPageUpdate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import NewBranchesSearch from '@/components/insights/NewBranchesSearch';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { sortJsonArrayHelper } from '@/mixins/sort-json-array.js';
import NewBranches from '../../../enums/NewBranches';

export default {
  name: 'NewBranchesReport',

  mixins: [
    axios,
    csvDownloadHelper,
    dataFormatter,
    sortJsonArrayHelper,
  ],

  components: {
    NewBranchesSearch,
  },

  props: {
    view: '',
  },

  data() {
    return {
      sales: [],
      loading: false,
      isGettingTotal: false,
      loadings: {},
      NewBranches: NewBranches,
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_new_branches.csv',
      searchParams: {
        reportType: 'CORPORATES',
        currentPage: 1,
        pagination: 40,
        total: 0,
      },
    };
  },

  async created() {
    this.isUserAuthorised();

    await this.getTotals();
  },

  methods: {
    async getTotals() {
      this.isGettingTotal = true;

      this.isUserAuthorised();

      const url = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetNewBranches?reportType=${this.searchParams.reportType}&getCount=1&cnt=1&start=0`;

      this.searchParams.total = (await Axios.get(url, this.returnHeaderUsingToken())).data[0]?.count || 0;

      this.isGettingTotal = false;
    },

    handleSortOrderChange(sortProps) {
      this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
    },

    csv(index) {
      this.$set(this.loadings, index, false);

      const endpoint = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetNewBranches?reportType=${this.searchParams.reportType}`;

      Axios.get(endpoint, this.returnHeaderUsingToken())
        .then(response => {
          const fields = this.NewBranches.createLabelValueList();

          this.downloadCsv(this.exportDate, fields, response.data);

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$set(this.loadings, index, false);
          });
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$set(this.loadings, index, false);
          });
        });
    },

    onCurrentPageUpdate(page) {
      this.searchParams.currentPage = page;
    },

    async onReportTypeChanged() {
      this.searchParams.currentPage = 1;
      this.searchParams.total = 0;

      await this.getTotals();
    },
  },
};
</script>